export const NEW_BATCHPOST = 'NEW';
export const SENT_BATCHPOST = 'SENT';
export const DELIVERED_BATCHPOST = 'DELIVERED';

export const itemTypes = { process: 'process', processinLot: 'processinLot', lot: 'lot' };